import { baseApi } from "./baseApi";

export const customerApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        validateCustomer: builder.mutation({
            query: (customerData) => ({
                url: "/customers/validate",
                method: "POST",
                data: customerData,
            }),
        }),
    })
})

export const { useValidateCustomerMutation } = customerApi;